'use strict'

const getCachePrice = require('./pricing/getCachedPrice.jsx')
const EmailSignup = require('./email-signup.jsx')
const seoSearch = require('./seoSearch.jsx')
const ReviewMeta = require('./reviews/reviews-meta.jsx')
const ParkingTable = require('./tables/parkingTable.jsx')
const MoreInfo = require('./moreInfo.jsx')
const ReviewsBootstrap = require('./reviews/reviews-results-bootstrap.jsx')
const MapDirections = require('./map/map.jsx')
const PhoneNumber = require('./phoneNumber.jsx')
const LastUpdated = require('./lastUpdated.jsx')
const productTable = require('./tables/productTable.jsx')
const DocWarrior = require('./markdown/DocWarrior.jsx')

/* Remapping old svn fields to react components */
const includes = {
  'cheapest-price': { component: getCachePrice, renderAtBuildTimeOnly: true },
  'email-signup': { component: EmailSignup, renderAtBuildTimeOnly: false },
  'seosearch': { component: seoSearch, renderAtBuildTimeOnly: true },
  'seosearchlist': { component: seoSearch, renderAtBuildTimeOnly: true },
  'airparks/more-info': { component: MoreInfo, renderAtBuildTimeOnly: true },
  'airparks/more-info-bootstrap': { component: MoreInfo, renderAtBuildTimeOnly: true },
  'airparks-bootstrap/aps-richsnips': { component: ReviewMeta, renderAtBuildTimeOnly: true },
  'airparks-new/bootstrap-price-comparison': { component: ParkingTable, renderAtBuildTimeOnly: true },
  'hx-new/reviews-results-bootstrap': { component: ReviewsBootstrap, renderAtBuildTimeOnly: true },
  'airparks-new/map-and-directions': { component: MapDirections, renderAtBuildTimeOnly: false },
  'ddi-number-aps': { component: PhoneNumber, renderAtBuildTimeOnly: false },
  'last-updated': { component: LastUpdated, renderAtBuildTimeOnly: true },
  'hx-new/aps-hotel-table-bootstrap': { component: productTable, renderAtBuildTimeOnly: true },
  'DocWarrior': { component: DocWarrior, renderAtBuildTimeOnly: false }
}

const makeBreadcrumb = (breadcrumb) => {
  breadcrumb = breadcrumb.replace(/##/g, '').replace('addBreadcrumb:', '')
  const matched = breadcrumb.match(/(.[^(]*)(\((.*)\))?/)
  if (!(matched && matched[1])) return { }
  let page = matched[1]
  let text = matched[3]
  let key = matched[0]
  if (!text) {
    text = page.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
  }
  if (key === page) {
    text = page
    page = ''
  }
  return {
    text,
    page,
    key
  }
}

const smartyVariables = (content, setVar) => {
  if (!setVar) setVar = { }
  if (!content) return { content, setVar }
  if (!(setVar && setVar.length)) setVar = { }
  const breadcrumbs = content.match(/##addBreadcrumb:([^#]*)##/g)
  const variables = content.match(/##setVariable:([^#]*)##/g)
  if (!variables && !breadcrumbs) return { content, setVar }
  variables.map(item => {
    content = content.replace(item, '')
    item = item.replace(/##/g, '').replace('setVariable:', '')
    const [ key, value ] = item.split(':')
    setVar[ key ] = value
  })
  if (breadcrumbs) {
    setVar.breadcrumb = breadcrumbs.reduce((crumbs, item) => {
      content = content.replace(item, '')
      const crumb = makeBreadcrumb(item)
      crumbs[crumb.key] = crumb
      return crumbs
    }, { })
  }
  return { content, setVar }
}

const removeComments = (content) => {
  if (!content) return ''
  content = content.replace(/<!--((?!-->)(.|\n))*-->/gmi, '')
  return content
}

const smartyIncludes = (content) => {
  if (!content) return [ ]
  content = removeComments(content)
  let matches = content.split(/##/g)
  let i = 0
  matches = matches.map(match => {
    try {
      const file = match.split(':')[0]
      let props = match.replace(file + ':', '').split(':')
      if (!match.split(':')[1]) props = [ ]
      const El = includes[ file ]
      if (El && El.noRender) {
        return {
          isCode: false,
          contents: ''
        }
      }
      if (!(El && El.component)) throw 'No React component in smartyIncludes object'
      return {
        isCode: true,
        renderAtBuildTimeOnly: El.renderAtBuildTimeOnly,
        contents: El.component,
        props,
        id: file.replace(/\//g, '-') + '-' + i++
      }
    } catch (e) {
      return {
        isCode: false,
        contents: match
      }
    }
  })
  return matches
}

module.exports = { smartyIncludes, smartyVariables }



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/smartyIncludes.jsx